import { render, staticRenderFns } from "./lock2-open.vue?vue&type=template&id=3066a3fb&"
import script from "./lock2-open.vue?vue&type=script&lang=js&"
export * from "./lock2-open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports